import React, { Component } from 'react'
import PropTypes from 'prop-types';


function IndoorOutdoor(outsideOnly) {
  if (outsideOnly) {
    return <li className="outdoor">Outdoor Comptabible</li>;
  }
  return <li className="indoor">Indoor Use Only</li>;
}

export class PackageItem extends Component {

  render() {

    return (
      <a className="packages-listing--card d-flex flex-column card " href={this.props.packageItem.url + '?location_id=' + this.props.location_id}>
        <div className="packages-listing--card__description row d-flex flex-row">
          <div className="col packages-listing--card__image">
            <img src={this.props.packageItem.thumbnail} alt={this.props.packageItem.title} className="img-fluid" />
          </div>
          <div className="col packages-listing--card__descriptionText flex-column flex-lg-row row">
            <div className="col">
              <h3>{this.props.packageItem.title}</h3>
              <ul className="packages-listing--card__keyIconList justify-content-stretch">
                <li className="capacity">
                  {"<"} {this.props.packageItem.capacity}
                </li>
                {IndoorOutdoor(this.props.packageItem.outside_compatible)}
              </ul>
              <p>{this.props.packageItem.blurb}</p>
            </div>
            <div className="col packages-listing--card__featuresList">
              <ul>{
                
        this.props.packageItem.usps.map((uspx) => {
            let uspImageUrl = uspx.image ? uspx.image.url : "";
            
            return <li key={uspx.usp.term_id} className={uspx.usp.slug} dangerouslySetInnerHTML={{ __html: uspx.usp.name }} /*style={{backgroundImage: ( "url(" + uspImageUrl  + ")")}}*/ ></li>})
        }
  </ul>
            </div>
          </div>
        </div>
        <div className="packages-listing--card__footer row d-flex align-items-center justify-content-between  flex-column flex-lg-row">
          <div className="col">
            <p className="price h3">
              <span className="price-prefix">from </span>£{this.props.packageItem.price} <span className="price-suffix">per day</span>
            </p>

            <p>{this.props.packageItem.subtitle}</p>
          </div>
          <div className="col packages-listing--card__footerButtons d-flex align-items-center justify-content-end flex-column flex-lg-row">
            <div className="btn btn-primary w-100">
              <span>Find out more</span>
            </div>
          </div>
        </div>
      </a>
    );
  }
}

// Good Packages
PackageItem.propTypes = {
    packageItem: PropTypes.object.isRequired,
    location_id: PropTypes.object.isRequired
}


export default PackageItem